import { useEffect } from "react";
import { LogOut, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { MyMT5 } from "@/components/MyMT5";
import { Masked } from "@/components/Masked";
import { EffectiveRules } from "@/components/EffectiveRules";
import { EndDayCard } from "@/components/EndDayCard";

export const ProfileDrawer = ({ open, onClose, status, settings, summary, onChange }) => {
  const { user, logout } = useAuth();

  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    if (open) document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80]" data-testid="profile-drawer">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <aside className="absolute right-0 top-0 h-full w-full sm:w-[420px] bg-[#0B0C0D] border-l border-zinc-800 overflow-y-auto">
        <div className="sticky top-0 bg-[#0B0C0D] border-b border-zinc-800 px-4 py-3 flex items-center gap-3">
          <div className="min-w-0">
            <p className="text-sm font-heading font-semibold tracking-tight text-zinc-50 truncate">
              <Masked
                value={user?.name || user?.email}
                kind={user?.name ? "name" : "email"}
                testid="profile-drawer-name"
              />
            </p>
            <p className="font-mono text-[11px] text-zinc-400 truncate" data-testid="drawer-email">
              <Masked value={user?.email} kind="email" testid="profile-drawer-email" /> ·{" "}
              {user?.role?.toUpperCase()}
            </p>
          </div>
          <div className="flex-1" />
          <button
            data-testid="profile-drawer-close"
            onClick={onClose}
            className="h-9 w-9 rounded-full border border-zinc-700 flex items-center justify-center text-zinc-300 hover:text-white hover:bg-zinc-800 transition-colors duration-200"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="p-4 flex flex-col gap-4 pb-28">
          <MyMT5 status={status} onChange={onChange} />
          <EffectiveRules rules={settings} />
          <EndDayCard summary={summary} onChange={onChange} />
          <button
            data-testid="logout-btn"
            onClick={logout}
            className="flex items-center justify-center gap-2 border border-zinc-700 text-zinc-200 hover:bg-red-600 hover:border-red-600 hover:text-white py-3 rounded-sm text-xs uppercase tracking-[0.12em] font-semibold transition-colors duration-200"
          >
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </aside>
    </div>
  );
};
